export const N_MODULES = 1739;
export const DOCUMENT_TITLE = "XeTeX: A Pseudoprogram";
